var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-avatar',{class:_vm.$vuetify.theme.isDark ? 'dark-orange pt-2' : 'orange lighten-5 pt-2',attrs:{"size":_vm.size ? _vm.size : '48',"rounded":"xl"}},[_c('h4',{staticClass:"text-capitalize font-weight-light orange--text"},[_vm._v(_vm._s(_vm.initials))])])
}
var staticRenderFns = []

export { render, staticRenderFns }